

/*
	Source: htdocs/wim/js/core/src/StickyNav.js
*/
(function($, wimbledonCore) {
/**
     *  Poller Class
     *      Used for setting up repeating AJAX loads. Supports
     *      a variety of options ranging from simple to complex.
     */
    function StickyNav() {
        var id = 'StickyNav';
        // eventsCore.setLogLevel('all');
        var logger = new eventsCore.util.Logger(id);
        var api = [];

        var _types = {
            scroll: 1,
            generic: 2
        };

        api.init = function(type) {
            var selector = window;
            var pageType = _types[type];
            if(pageType === _types.generic) {
                selector = '.genericMain';
            }

            var scrollSection,
                azNav,
                azNavHeight,
                azFill,
                relativeContainer,
                animateElem,

                content,
                offsetTop,
                offset = 0,
                scrollWidth = 0
            ;

            $(document).ready(function(){
                scrollSection = $(selector);
                azNav = $('.azText');
                azFill = $('.azTextFill');
                relativeContainer = scrollSection;
                animateElem = scrollSection;

                if(azFill.length === 0) {
                    azFill = $('<div class="azTextFill"></div>');
                    azNav.after(azFill);
                }

                if(pageType === _types.generic) {
                    content = azNav.prev();
                } else {
                    content = azFill.parent();
                    animateElem = $('html,body');
                }
                setOffsetTop();

                if(pageType !== _types.generic) {
                    offset = (110 + 20);
                    relativeContainer = $('#rightGradient');
                }

                // detect scrollbar width for overflow scrolling on genericMain
                if(scrollSection[0] !== window) {
                    scrollWidth = scrollSection[0].offsetWidth - scrollSection[0].clientWidth;
                }

                azNavHeight = azNav.outerHeight(true);
                azFill.height(azNavHeight);

                scrollSection.on("scroll", updatePosition);
                $(window).on("resize", updatePosition);

                updatePosition();

                // allow SelectAnchor to handle jumps to letter header, it also handles switch between mobile/desktop
            });

            function updatePosition() {
                // logger.info('scrollSection - pos:%o mainTop:%o cont:%o', $(this).scrollTop(), scrollSection.position().top, azNav.offset().top);
                setOffsetTop();
                var scrollTop = scrollSection.scrollTop();

                logger.info('scrollSection - pos:%o offsetTop:%o', scrollTop, offsetTop);

                if (scrollTop >= offsetTop) {
                    var setTop = scrollTop;
                    if(pageType !== _types.generic) {
                        setTop -= offsetTop;
                    }
                    azNav.addClass("fix-nav").css('top', setTop);
                    azFill.addClass("fix-nav");
                }
                else {
                    azNav.removeClass("fix-nav").css('top','');
                    azFill.removeClass("fix-nav");
                }
            }

            function setOffsetTop() {
                if(pageType === _types.generic) {
                    offsetTop = content.position().top + content.outerHeight() - offset;
                } else {
                    offsetTop = content.offset().top - offset;
                }
            }

            function scrollTo(pos) {
                if(pageType !== _types.generic) {
                    pos += content.position().top - 110;
                }
                animateElem.animate({
                    scrollTop: pos
                });
            }
        };

        return api;
    };

    wimbledonCore.stickyNav = new StickyNav();

}(jQuery, window.wimbledonCore));